import {
  Attribute,
  Component,
  Injector, OnInit,
  Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {FormsModule} from "@angular/forms";
import {CURRENCY_INFO, runtimeEventManager} from "@wm/core";
import {get} from "lodash-es";
import { getAppDefault } from '../utils/appDefaults';

const DEFAULT_CLS = 'input-group app-currency';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-currency',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmCurrency]',
  template: `<span class="input-group-addon" [textContent]="currencySymbol"></span>
  <input class="form-control app-textbox app-currency-input"
         role="textbox"
         type="text"
         inputmode="decimal"
         focus-target
         [autofocus]="autofocus"
         [readonly]="readonly"
         [disabled]="disabled"
         [required]="required"
         [pattern]="regexp"
         [attr.name]="name"
         [attr.aria-label]="hint || currencyCode"
         [attr.tabindex]="tabindex"
         [attr.placeholder]="placeholder"
         [attr.accesskey]="shortcutkey"
         [ngModel]="displayValue"
         [ngModelOptions]="ngModelOptions"
  >
  `,
  providers: [
    provideAsWidgetRef(CurrencyComponent)
  ],
  exportAs: 'wmCurrency',
  standalone: true,
  imports: [CommonModule, FormsModule],
  styles: []
})
export class CurrencyComponent extends StylableComponent implements OnInit {
  static initializeProps = register('wm-currency');

  currencyCode: string;
  currencySymbol: string;
  public required: boolean;
  public regexp: any;
  public disabled: boolean;
  public autofocus: boolean;
  public name: string;
  public tabindex: any;
  public shortcutkey: string;
  public hint: string;
  public placeholder: string;
  public displayValue: string;
  public ngModelOptions: any;
  public readonly : boolean;
  private proxyModel: number;
  private currency: any;
  constructor(inj: Injector, @Optional() viewParent: Parent, @Attribute('currency') public _currency: string) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  override ngOnInit() {
    super.ngOnInit();
    if (!this._currency) {
      this.setAppDefaultForProp();
    }
  }

  setAppDefaultForProp() {
    let currency = getAppDefault('currencyCode');
    if (!currency) {
      runtimeEventManager.on('wms:app-defaults-ready').subscribe(() => {
        this.widget['currency'] = getAppDefault('currencyCode') || 'USD';
      });
      return;
    }
    this.widget['currency'] = currency || 'USD';
  }

  override get stylerEl(): HTMLElement {
    return this.nativeElement.querySelector('input.app-currency-input') || this.nativeElement;
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'currency'){
      this.currencyCode = nv;
      this.currencySymbol = get(CURRENCY_INFO,this.currencyCode).symbol;
    }else {
      super.onPropertyChange(key, nv, ov);
    }
  }
  set datavalue(value: number){
    this.displayValue = value.toString();
    this.proxyModel = value;
  }
  get datavalue(){
    return this.proxyModel;
  }
}

